import { render } from "./ProjectQuotationListWidget.vue?vue&type=template&id=43ec68af&scoped=true"
import script from "./ProjectQuotationListWidget.vue?vue&type=script&lang=js"
export * from "./ProjectQuotationListWidget.vue?vue&type=script&lang=js"

import "./ProjectQuotationListWidget.vue?vue&type=style&index=0&id=43ec68af&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ec68af"]])

export default __exports__